/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".platform-tour-modal-window .modal-dialog{max-width:820px;width:calc(100vw - 2rem)}.platform-tour-modal-window .modal-content{border-radius:24px}.platform-tour-modal,.platform-tour-modal-content{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:center;align-items:center}.platform-tour-modal-content{padding-inline:120px;margin-block:80px 64px;row-gap:40px}.platform-tour-modal-image{width:100%;padding-inline:32px}.close{font-size:18px;position:absolute;top:24px;right:24px}"];
export { styles as styles };
//# sourceMappingURL=platform-tour-modal.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/platform-tour/platform-tour-modal/platform-tour-modal.component.scss.ngstyle.js
// module id = 1415
// module chunks = 27 28 29